// extracted by mini-css-extract-plugin
export default {"main":"Pagination_main__xXWNB","box":"Pagination_box__kFR8h","list":"Pagination_list__1P8Eq","number":"Pagination_number__CSIvg","numberActive":"Pagination_numberActive__xp95f"};